export const imageCardSx = { position: 'relative' };

export const colorOverlay = (theme) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0.6,
  zIndex: 100,
  backgroundColor: theme.palette.tertiary.main,
  width: '345px',
  height: '194px',
});

export const overlayHeadingSx = {
  position: 'absolute',
  top: '24px',
  left: '24px',
  zIndex: 200,
  width: '50%',
};

export const headingSx = {
  color: '#fff',
  fontSize: '40px !important',
};
